export const H2Fields = [
    { identifier: 'font-size-h2', type: 'input', field: 'font-size-h2' },
    { identifier: 'font-weight-h2', type: 'input', field: 'font-weight-h2' },
    { identifier: 'font-color-h2', type: 'input', field: 'font-color-h2' }
]
